import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IEducationalScenarioItem } from "../types/IEducationalScenarioItem";

export interface IEducationalScenarioItemQueryParameters {
    educationalScenarioItem?: RelationalValue<IEducationalScenarioItem>;
}

export type IEducationalScenarioItemQueryResult = IEducationalScenarioItem;

export const educationalScenarioItemQuery: IApiQueryFunction<IEducationalScenarioItemQueryParameters> = ({
    educationalScenarioItem,
}) => {
    if (!educationalScenarioItem) {
        return;
    }

    return {
        method: "GET",
        url: `/educational_scenario_items/${mapRelationalValue(educationalScenarioItem)}`,
    };
};

export const useEducationalScenarioItemQuery = createApiQueryHook<
    IEducationalScenarioItemQueryParameters,
    IEducationalScenarioItemQueryResult
>(educationalScenarioItemQuery);
